module.exports = __webpack_public_path__ + "img/Egypt.b167bb82.png";